import React, { useState } from 'react';
import { Box, FormLabel, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AddIconSvg, DeleteIcon } from '../../../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../../../Common/OKRButton';
import { ErrorIcon } from '../../../../../config/svg/formElementIcons';

export const CreateSkillFramework: React.FC<any> = (props: any) => {
	const {
		skillFramework,
		handleOnChange,
		handleLevelChange,
		handleAddLevel,
		handleRemoveLevel,
		handleProficiencyChange,
		handleAddProficiency,
		handleRemoveProficiency,
		frameworkError,
		setFrameworkError,
	} = props;
	const { t } = useTranslation();

	return (
		<>
			<Box className='drawer-content-panel skill-framework-panel'>
				<form className='drawer-form-fields' noValidate autoComplete='off'>
					<Box className='skill-framework-form'>
						{/* Framework Name */}
						<Box className='drawer-input-field'>
							<Box className='skill-framework-name-field'>
								<TextField
									fullWidth
									id='frameworkName'
									className='field-col2 helperText-bottom'
									label={t('frameworkName')}
									placeholder={t('frameworkPlaceholder')}
									name='frameworkName'
									value={skillFramework.frameworkName}
									onChange={(e) => handleOnChange('frameworkName', e.target.value)}
									InputLabelProps={{ shrink: true }}
									InputProps={{ 'aria-label': t('frameworkName'), disableUnderline: true }}
									error={frameworkError?.frameworkName || false}
									helperText={
										frameworkError?.frameworkName ? (
											<>
												<ErrorIcon /> {frameworkError?.frameworkName || ''}
											</>
										) : null
									}
								/>
							</Box>
						</Box>

						{/* Framework Description */}
						<Box className='drawer-input-field'>
							<Box className='skill-framework-desc-field'>
								<TextField
									fullWidth
									id='frameworkDescription'
									className='helperText-bottom'
									label={t('frameworkDescription')}
									name='description'
									placeholder={t('descriptionPlaceholder')}
									multiline
									minRows={2}
									value={skillFramework.description}
									onChange={(e) => handleOnChange('description', e.target.value)}
									InputLabelProps={{ shrink: true }}
									InputProps={{ 'aria-label': t('frameworkDescription'), disableUnderline: true }}
								/>
							</Box>
						</Box>
						{/* Levels */}
						<Box className='drawer-input-field drawer-blue-bg-full'>
							<Box className='skill-framework-level-form'>
								{skillFramework.levels.map((level: any, index: number) => (
									<Box className='framework-level-row' key={index}>
										<Box className='framework-level-col-1'>
											<Box className={`level-title ${!level.isActive ? 'disabled' : ''}`}>
												<Typography variant='h5'>{`${t('levelText')} ${index + 1}`}</Typography>
											</Box>
											<TextField
												fullWidth
												id={`levelName-${index}`}
												className='framework-level-field helperText-bottom'
												placeholder={`${!level.isActive ? t('addLevelText') : t('levelPlaceholder')}`}
												value={level.name}
												onChange={(e) => handleLevelChange(index, 'name', e.target.value)}
												disabled={!level.isActive}
												InputLabelProps={{ shrink: true }}
												InputProps={{
													'aria-label': `${t('levelText')} ${index + 1}`,
													disableUnderline: true,
												}}
												error={frameworkError?.levels[index]?.name || false}
												helperText={
													frameworkError?.levels[index]?.name ? (
														<>
															<ErrorIcon /> {frameworkError?.levels[index]?.name || ''}
														</>
													) : null
												}
											/>
										</Box>
										<Box className='framework-level-col-2'>
											{level.isActive && (
												<TextField
													fullWidth
													id={`levelDescription-${index}`}
													className='helperText-bottom'
													placeholder={t('levelDescriptionPlaceholder')}
													value={level.description}
													onChange={(e) => handleLevelChange(index, 'description', e.target.value)}
													disabled={!level.isActive}
													InputLabelProps={{ shrink: true }}
													InputProps={{
														'aria-label': t('levelDescription', { level: index + 1 }),
														disableUnderline: true,
													}}
													error={frameworkError?.levels[index]?.description || false}
													helperText={
														frameworkError?.levels[index]?.description ? (
															<>
																<ErrorIcon /> {frameworkError?.levels[index]?.description || ''}
															</>
														) : null
													}
												/>
											)}
										</Box>
									</Box>
								))}
							</Box>
						</Box>
						{/* Proficiency Scales */}
						<Box className='drawer-input-field'>
							<Box className='skill-framework-proficiency-form'>
								<Box
									className={`skill-level-head ${frameworkError?.proficiencyScalesCount ? 'helperText-bottom' : ''}`}
								>
									<FormLabel component='legend'>{t('proficiencyLevel')}</FormLabel>
									{frameworkError?.proficiencyScalesCount && (
										<Typography className='error-field'>{frameworkError?.proficiencyScalesCount}</Typography>
									)}
								</Box>
								<Box className='skill-framework-proficiency-form-inner'>
									{skillFramework.proficiencyScales.map((proficiency: any, index: number) => (
										<Box className='framework-proficiency-row' key={index}>
											<Box className='framework-proficiency-col-1'>
												<TextField
													id={`proficiencyName-${index}`}
													className='framework-proficiency-field helperText-bottom'
													placeholder={`${t('addProficiencyLevel')}`}
													value={proficiency.proficiencyScaleName}
													onChange={(e) => handleProficiencyChange(index, 'proficiencyScaleName', e.target.value)}
													InputLabelProps={{ shrink: true }}
													InputProps={{
														'aria-label': `${t('proficiencyLevel')} ${index + 1}`,
														disableUnderline: true,
													}}
													error={frameworkError?.proficiencyScales[index]?.proficiencyScaleName || false}
													// helperText={
													// 	frameworkError?.proficiencyScales[index]?.proficiencyScaleName ? (
													// 		<>
													// 			<ErrorIcon /> {frameworkError?.proficiencyScales[index]?.proficiencyScaleName || ''}
													// 		</>
													// 	) : null
													// }
												/>
												<TextField
													fullWidth
													id={`proficiencyDescription-${index}`}
													className='framework-proficiency-desc-field helperText-bottom'
													placeholder={t('proficiencyDescriptionPlaceholder')}
													multiline
													minRows={2}
													value={proficiency.proficiencyScaleDescription}
													onChange={(e) =>
														handleProficiencyChange(index, 'proficiencyScaleDescription', e.target.value)
													}
													InputLabelProps={{ shrink: true }}
													InputProps={{
														'aria-label': t('proficiencyDescripton'),
														disableUnderline: true,
													}}
													error={frameworkError?.proficiencyScales[index]?.proficiencyScaleDescription || false}
													// helperText={
													// 	frameworkError?.proficiencyScales[index]?.proficiencyScaleDescription ? (
													// 		<>
													// 			<ErrorIcon />{' '}
													// 			{frameworkError?.proficiencyScales[index]?.proficiencyScaleDescription || ''}
													// 		</>
													// 	) : null
													// }
												/>
											</Box>
											<Box className='framework-proficiency-col-2'>
												{skillFramework.proficiencyScales.length > 1 && (
													<OKRButton
														className='editIcon'
														icon={<DeleteIcon />}
														handleClick={() => handleRemoveProficiency(index)}
													/>
												)}
											</Box>
										</Box>
									))}
									<Box className='section-actions'>
										<OKRButton
											className='btn-add-key'
											icon={<AddIconSvg />}
											id='add-proficiency-btn'
											text='Add Proficiency'
											handleClick={handleAddProficiency}
										/>
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				</form>
			</Box>
		</>
	);
};
